document.addEventListener("DOMContentLoaded", function () {
  document.querySelector(".menu-ttl").addEventListener("click", function () {
    this.classList.toggle("is-active");
    document.querySelector(".main-menu").classList.toggle("active");
  });

  document.querySelectorAll(".accordion-toggle").forEach(function (toggle) {
    toggle.addEventListener("click", function (event) {
      event.stopPropagation();
      let submenu = this.parentElement.nextElementSibling;
      if (submenu && submenu.tagName === "UL") {
        submenu.classList.toggle("active");
        this.classList.toggle("is-active");
      }
    });
  });
});

